/* global gapi */

import config from '../config'

export {
    GoogleInit,
    GoogleLogin,
    GoogleLogout,
    GoogleGetAuthQuery,
    GoogleCheckAuthStatus,
}

async function GoogleInit() {
    return new Promise((resolve, reject) => {
        gapi.load('auth2', async () => {
            await gapi.auth2.init({
                client_id: config.GoogleClientID,
            }).then()
            resolve(true)
        })
    })
}

async function GoogleLogin() {
    const GoogleAuth = gapi.auth2.getAuthInstance()

    try {
        const GoogleUser = await GoogleAuth.signIn()
        const BasicProfile = GoogleUser.getBasicProfile()

        // this obj should be same properties with facebook one
        return {
            id: BasicProfile.getId(),
            name: BasicProfile.getName(),
            email: BasicProfile.getEmail(),
        }
    } catch (err) {
        return nil
    }
}

async function GoogleLogout() {
    const GoogleAuth = gapi.auth2.getAuthInstance()
    try {
        await GoogleAuth.signOut()
        return true
    } catch (err) {
        return nil
    }
}

function GoogleGetAuthQuery() {
    const GoogleAuth = gapi.auth2.getAuthInstance()
    const GoogleUser = GoogleAuth.currentUser.get()
    const AuthResponse = GoogleUser.getAuthResponse()

    return {
        auth: 'google',
        access_token: AuthResponse.id_token,
    }
}

function GoogleCheckAuthStatus() {
    const GoogleAuth = gapi.auth2.getAuthInstance()
    const ok = GoogleAuth.isSignedIn.get()

    return ok
}